import React from "react";
import { useContent } from "../context/ContentContext";
import { useAuth } from "../context/AuthContext";
import { Pencil, Eye, X } from "lucide-react";

export default function EditToolbar() {
  const { isAdmin, editMode, setEditMode } = useContent();
  const { logout } = useAuth();
  if (!isAdmin) return null;

  return (
    <div
      className="fixed z-[9999] bottom-6 right-6 flex items-center gap-2 rounded-full pl-3 pr-2 py-2 shadow-2xl border backdrop-blur-md"
      style={{ background: "rgba(14,42,28,0.94)", borderColor: "rgba(255,255,255,0.15)" }}
      data-testid="edit-toolbar"
    >
      <span className="text-white text-xs font-semibold uppercase tracking-wider mr-2 flex items-center gap-1.5">
        <span className="w-1.5 h-1.5 rounded-full" style={{ background: editMode ? "#22c55e" : "#f59e0b" }} />
        Admin
      </span>
      <button
        onClick={() => setEditMode(!editMode)}
        className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition ${editMode ? "text-white" : "text-white/85 hover:text-white"}`}
        style={editMode ? { background: "var(--brand-500)" } : { background: "rgba(255,255,255,0.1)" }}
        data-testid="toggle-edit-mode"
      >
        {editMode ? <><Pencil size={12} /> Editing</> : <><Eye size={12} /> View</>}
      </button>
      <a href="/admin" className="text-white/70 hover:text-white text-xs px-2 py-1.5 rounded-full hover:bg-white/10" title="Admin Dashboard">CMS</a>
      <button onClick={logout} className="text-white/50 hover:text-white/90 p-1.5 rounded-full hover:bg-white/10" title="Sign out">
        <X size={13} />
      </button>
    </div>
  );
}
